export default {
  name: "MessageSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M9.5 30a1 1 0 0 1-.98-1.2l.76-3.8H5c-1.16 0-2-.84-2-2V6c0-1.16.84-2 2-2h22c1.16 0 2 .84 2 2v17c0 1.16-.84 2-2 2H16.7a.84.84 0 0 0-.58.18l-6.01 4.61a.98.98 0 0 1-.61.21z",
  },
}
